<template>
  <svg class="icon" v-if="name !== ''" :height="height" :width="width" :fill="fill" :stroke="stroke"><use :xlink:href="sprite + '#' + name" :href="sprite + '#' + name"></use></svg>
</template>

<script>
import Sprite from '@/assets/sprite.svg'

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    fill: {
      type: String
    },
    stroke: {
      type: String
    }
  },
  data () {
    return {
      sprite: Sprite
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  vertical-align: baseline;
}
</style>
